export default (selector = ".js-scroll-snap-bleed") => {
  const snapMarkers = document.querySelectorAll(selector);

  if (snapMarkers.length < 1) return;

  const options = {
    rootMargin: "-50% 0px -50% 0px",
    threshold: 0,
  };

  let numIntersecting = 0;
  let firstIntersection = true;
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        numIntersecting++;
      } else if (numIntersecting > 0 && !firstIntersection) {
        numIntersecting--;
      }
    });

    if (numIntersecting > 0) {
      document.documentElement.classList.add("u-snap-block");
    } else {
      document.documentElement.classList.remove("u-snap-block");
    }

    if (firstIntersection) {
      firstIntersection = false;
    }
  }, options);

  snapMarkers.forEach((container) => {
    observer.observe(container);
  });
};
